import { useEffect } from 'react';

export function useTitle(title: string) {
  useEffect(() => {
    // Empty title is a no-op so callers can opt out (e.g. an embedded list page
    // inside a record tab) without leaving the parent's document.title behind.
    if (!title) {
      return;
    }
    const previousTitle = document.title;
    document.title = `${title} - Ahoy - AI Native CRM`;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
